"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { useFormSubmission } from "@/hooks/use-form-submission";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Field, FieldError, FieldGroup, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { formSchema, FormSchemaType } from "@/lib/form-schema";
import { PhoneInput } from "../reui/phone-input";
import { Checkbox } from "../ui/checkbox";
import Link from "next/link";
import { useRouter } from "next/navigation";
const BannerCorporateEnquiryPopupFormSchema = formSchema.pick({
  fullName: true,
  email: true,
  contactNumber: true,
  teamSize: true,
  enquiryType: true,
  serviceId: true,
  terms: true
});
type BannerCorporateEnquiryPopupFormProps = {
  serviceId?: number;
  onSuccess?: () => void;
};
export function BannerCorporateEnquiryPopupForm(t0) {
  const $ = _c(31);
  const {
    serviceId,
    onSuccess
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = zodResolver(BannerCorporateEnquiryPopupFormSchema as any);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== serviceId) {
    t2 = {
      resolver: t1,
      defaultValues: {
        fullName: "",
        email: "",
        contactNumber: "",
        teamSize: "1",
        serviceId: serviceId ? [serviceId] : [],
        enquiryType: "CORPORATE_ENQUIRY",
        terms: false
      }
    };
    $[1] = serviceId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const form = useForm(t2);
  let t3;
  if ($[3] !== form || $[4] !== onSuccess || $[5] !== router) {
    t3 = t4 => {
      const {
        name,
        message
      } = t4;
      form.reset();
      onSuccess?.();
      sessionStorage.setItem("thankYouData", JSON.stringify({
        name,
        message
      }));
      router.push("/thank-you-for-enquiry");
    };
    $[3] = form;
    $[4] = onSuccess;
    $[5] = router;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== form.setError || $[8] !== t3) {
    t4 = {
      setError: form.setError,
      onSuccess: t3
    };
    $[7] = form.setError;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    submit,
    isSubmitting
  } = useFormSubmission(t4);
  let t5;
  if ($[10] !== submit) {
    t5 = async function onSubmit(data) {
      await submit(data);
    };
    $[10] = submit;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const onSubmit = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CardHeader><CardTitle>Corporate Training Enquiry</CardTitle><CardDescription>Receive customized pricing, delivery options, and course recommendations quickly.</CardDescription></CardHeader>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== form || $[14] !== onSubmit) {
    t7 = form.handleSubmit(onSubmit);
    $[13] = form;
    $[14] = onSubmit;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== form.control) {
    t8 = <FieldGroup><Controller name="fullName" control={form.control} render={_temp} /><Controller name="contactNumber" control={form.control} render={_temp2} /><Controller name="email" control={form.control} render={_temp3} /><Controller name="teamSize" control={form.control} render={_temp4} /><Controller name="terms" control={form.control} render={_temp5} /></FieldGroup>;
    $[16] = form.control;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <CardContent><form id="banner-corporate-enquiry-form" onSubmit={t7}>{t8}</form></CardContent>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== form || $[22] !== onSubmit) {
    t10 = form.handleSubmit(onSubmit);
    $[21] = form;
    $[22] = onSubmit;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isSubmitting ? "Submitting..." : "Submit";
  let t12;
  if ($[24] !== isSubmitting || $[25] !== t10 || $[26] !== t11) {
    t12 = <CardFooter className="bg-card border-0"><Field orientation="horizontal"><Button type="submit" onClick={t10} disabled={isSubmitting}>{t11}</Button></Field></CardFooter>;
    $[24] = isSubmitting;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t9) {
    t13 = <Card className="ring-0">{t6}{t9}{t12}</Card>;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp5(t0) {
  const {
    field: field_3,
    fieldState: fieldState_3
  } = t0;
  return <Field data-invalid={fieldState_3.invalid} orientation="horizontal" className="col-span-1 md:col-span-2"><Checkbox id="banner-corporate-enquiry-form-terms" name={field_3.name} checked={field_3.value} onCheckedChange={field_3.onChange} /><FieldLabel htmlFor="banner-corporate-enquiry-form-terms" className="font-normal"><span>I agree to Spoclearn{" "}<Link href="/terms-and-conditions" className="text-primary font-semibold">terms of use</Link>{" "}and privacy policy</span></FieldLabel>{fieldState_3.invalid && <FieldError errors={[fieldState_3.error]} />}</Field>;
}
function _temp4(t0) {
  const {
    field: field_2,
    fieldState: fieldState_2
  } = t0;
  return <Field data-invalid={fieldState_2.invalid}><FieldLabel htmlFor="banner-corporate-enquiry-form-teamSize">Team Size</FieldLabel><Input {...field_2} type="number" required={true} id="banner-corporate-enquiry-form-teamSize" aria-invalid={fieldState_2.invalid} placeholder="Team size" autoComplete="off" />{fieldState_2.invalid && <FieldError errors={[fieldState_2.error]} />}</Field>;
}
function _temp3(t0) {
  const {
    field: field_1,
    fieldState: fieldState_1
  } = t0;
  return <Field data-invalid={fieldState_1.invalid}><FieldLabel htmlFor="banner-corporate-enquiry-form-email">Email</FieldLabel><Input {...field_1} id="banner-corporate-enquiry-form-email" aria-invalid={fieldState_1.invalid} placeholder="Please enter your email" autoComplete="off" required={true} />{fieldState_1.invalid && <FieldError errors={[fieldState_1.error]} />}</Field>;
}
function _temp2(t0) {
  const {
    field: field_0,
    fieldState: fieldState_0
  } = t0;
  return <Field data-invalid={fieldState_0.invalid}><FieldLabel htmlFor="banner-corporate-enquiry-form-contactNumber">Phone</FieldLabel><PhoneInput defaultCountry="US" {...field_0} id="banner-corporate-enquiry-form-contactNumber" aria-invalid={fieldState_0.invalid} placeholder="Please enter your phone" autoComplete="off" required={true} />{fieldState_0.invalid && <FieldError errors={[fieldState_0.error]} />}</Field>;
}
function _temp(t0) {
  const {
    field,
    fieldState
  } = t0;
  return <Field data-invalid={fieldState.invalid}><FieldLabel htmlFor="banner-corporate-enquiry-form-fullName">Full Name</FieldLabel><Input {...field} id="banner-corporate-enquiry-form-fullName" aria-invalid={fieldState.invalid} placeholder="Please enter your Full name" autoComplete="off" required={true} />{fieldState.invalid && <FieldError errors={[fieldState.error]} />}</Field>;
}